import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "src/shared/api/base-query";
import { pagedQueryFn } from "src/shared/api/paged-query-fn";

import { ICropTypeDto } from "../shared";

export const cropTypesApi = createApi({
  reducerPath: "cropTypesApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchCropTypes: builder.query<ICropTypeDto[], void>({
      queryFn: pagedQueryFn<ICropTypeDto, ICropTypeDto[]>(
        { url: "CropTypesV2" },
        (dtos) => dtos
      ),
    }),
  }),
});

export const { useFetchCropTypesQuery } = cropTypesApi;
